<ng-container *ngIf="phxGroupRow; else normalRow">
  <td
    class="phx-table-row-group-header-cell"
    [attr.colspan]="selectable ? visibleColumns.length + 1 : visibleColumns.length"
  >
    <div class="phx-table-row-group-header" (click)="onGroupToggle($event)">
      <phx-checkbox
        *ngIf="phxShowGroupCheckbox"
        class="phx-table-row-group-checkbox"
        [phxChecked]="phxGroupChecked"
        [phxIndeterminate]="phxGroupIndeterminate"
        [disabled]="phxDisabled"
        (click)="$event.stopPropagation()"
        (phxCheckedChange)="onGroupCheckboxChange($event)"
      ></phx-checkbox>
      <i
        phx-icon
        class="phx-table-row-group-chevron"
        [class.phx-table-row-group-chevron-open]="phxGroupOpen"
        [phxIcon]="ChevronIcon"
        [size]="16"
      ></i>
      <ng-container *ngIf="groupHeader; else structuredHeader">
        <ng-container *ngTemplateOutlet="groupHeader.templateRef"></ng-container>
      </ng-container>
      <ng-template #structuredHeader>
        <span *ngIf="phxGroupTitle" class="phx-table-row-group-title">{{ phxGroupTitle }}</span>
        <i *ngIf="phxGroupTitle && phxGroupSubtitle" phx-icon [phxIcon]="BulletIcon"></i>
        <span *ngIf="phxGroupSubtitle" class="phx-table-row-group-subtitle">{{ phxGroupSubtitle }}</span>
        <i *ngIf="phxGroupItemsCount != null" phx-icon [phxIcon]="BulletIcon"></i>
        <phx-badge
          *ngIf="phxGroupItemsCount != null"
          [phxText]="phxGroupItemsCount.toString()"
          phxIntent="neutral"
          phxContrast="low"
        ></phx-badge>
      </ng-template>
    </div>
  </td>
</ng-container>

<ng-template #normalRow>
  <td
    *ngIf="selectable && phxShowSelectionCell"
    class="phx-table-control-cell"
    [attr.rowspan]="phxSelectionRowspan"
    [phxStickyCol]="checkboxStickyInfo"
  >
    <phx-checkbox
      [phxChecked]="selected"
      [disabled]="phxDisabled"
      (click)="$event.stopPropagation()"
      (phxCheckedChange)="onCheckboxChange()"
    ></phx-checkbox>
  </td>
  <ng-container *ngFor="let col of visibleColumns; trackBy: trackByKey">
    <td
      *ngIf="cellDirectiveMap.has(col.key) && !cellDirectiveMap.get(col.key)?.phxSkip"
      phx-table-cell
      [phxAlign]="cellDirectiveMap.get(col.key)?.phxAlign ?? cellStyleMap.get(col.key)?.align"
      [phxHighlightBorder]="cellDirectiveMap.get(col.key)?.phxHighlightBorder ?? false"
      [phxHighlightIntent]="cellDirectiveMap.get(col.key)?.phxHighlightIntent"
      [phxLoading]="cellDirectiveMap.get(col.key)?.phxLoading ?? false"
      [phxBorderLeft]="cellDirectiveMap.get(col.key)?.phxBorderLeft || false"
      [phxBorderRight]="
        cellDirectiveMap.get(col.key)?.phxBorderRight || cellStyleMap.get(col.key)?.groupBorderRight || false
      "
      [phxVerticalAlign]="cellDirectiveMap.get(col.key)?.phxVerticalAlign ?? 'middle'"
      [phxColspan]="cellDirectiveMap.get(col.key)?.phxColspan"
      [phxRowspan]="cellDirectiveMap.get(col.key)?.phxRowspan"
      [phxStickyCol]="cellStyleMap.get(col.key)?.stickyInfo"
    >
      <ng-container *ngTemplateOutlet="cellDirectiveMap.get(col.key)?.templateRef"></ng-container>
    </td>
  </ng-container>
</ng-template>
